import React from 'react';
import HelpIcon from '@mui/icons-material/Help';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useAtomValue, useSetAtom } from 'jotai';
import { diagnosticParcellesState, validatedAreaState } from '@/store';
import { getAreaAsHectares } from '@/utils/stringutils';
import styles from './BottomRightCtrl.module.scss';

export default function ButtomRightCtrl() {
  const area = useAtomValue(validatedAreaState);

  const theme = useTheme();

  const setDiagnosticParcelles = useSetAtom(diagnosticParcellesState);

  const onClick = () => {
    setDiagnosticParcelles({
      parcelles: [],
      contraintes: null,
    });
  };

  return (
    <>
      <Fade in={area > 0}>
        <Paper elevation={4} className={styles.bottomContainer}>
          <Typography className={styles.bottomContent} variant="subtitle1" color="primary">
            {getAreaAsHectares(area)}
          </Typography>
        </Paper>
      </Fade>
      <Fade in={area === 0}>
        <Paper
          elevation={4}
          className={styles.bottomContainer}
          sx={{ backgroundColor: theme.palette.secondary.main, maxWidth: 240 }}
        >
          <Button onClick={onClick} sx={{ color: '#fff' }}>
            <HelpIcon sx={{ mr: 1, fontSize: 30 }} />
            Vous ne trouvez pas vos parcelles ?
          </Button>
        </Paper>
      </Fade>
    </>
  );
}
